import type { OfferedEndingCause } from "../types/involvementEnding.js";

/**
 * Whether an ending with this cause must also say why in words. `other` says
 * nothing of what happened, so the words are all a later reader has.
 */
export const isReasonNeededForEndingCause = (
  cause: OfferedEndingCause,
): boolean => cause === "other";
